import { propertyValuesRelationNormalizer } from '../normalizers/propertyValuesRelationNormalizer'

export const listVacanciesAdapter = (data: any) => {
  if (!data) return []
  return data.map((item: any) => {
    if (item && Array.isArray(item.propertyValuesRelation)) {
      const {
        region = [],
        schedule = [],
        specialization = [],
      } = propertyValuesRelationNormalizer(item.propertyValuesRelation)
      return {
        name: item.name,
        code: item.code,
        specializationName: specialization[0]?.name,
        tags: {
          region: region[0]?.name,
          employmentForm: schedule[0]?.name,
        },
      }
    }

    const { name, code, region, employmentForm, specializations } = item
    return {
      name,
      code,
      specializationName: specializations?.[0],
      tags: { region, employmentForm },
    }
  })
}
